<template>
  <div class="customer-inquiry-resolved">
    <GChart id="ิbot-inquiry-resolved-chart" class="g-chart" type="BarChart" :data="chartData" :options="chartOptions" />
    <div class="inquiry-resolved-container-wrapper">
      <div class="inquiry-resolved-container">
        <div class="inquiry-resolved-box inquiry-resolved-box--answer_yes" />
        <p>Yes</p>
      </div>
      <div class="inquiry-resolved-container">
        <div class="inquiry-resolved-box inquiry-resolved-box--answer_no" />
        <p>No</p>
      </div>
    </div>
  </div>
</template>
<script>
import { GChart } from 'vue-google-charts';

export default {
  name: 'CustomerInquiryResolvedWidget',
  components: {
    GChart,
  },
  props: {
    surveyed_resolution: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      chartOptions: {
        legend: 'none',
        bars: 'horizontal',
        hAxis: { format: 'short' },
        annotations: {
          alwaysOutside: true,
          datum: {
            stem: {
              color: 'transparent',
            },
          },
        },
        tooltip: { trigger: 'none' },
      },
    };
  },
  computed: {
    chartData() {
      return [
        ['inquiry resolved', '', { role: 'style' }, { role: 'annotation' }],
        ['Yes', this.surveyed_resolution.answer_yes, '#50CD89', `${this.surveyed_resolution.answer_yes} (${this.surveyed_resolution.percentage_yes}%)`],
        ['No', this.surveyed_resolution.answer_no, '#EF6767', `${this.surveyed_resolution.answer_no} (${this.surveyed_resolution.percentage_no}%)`],
      ];
    },
  },
};
</script>
<style lang="scss" scoped>
.customer-inquiry-resolved {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 20px;
  p {
    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
    color: #646a8c;
    margin: 0;
  }
  .inquiry-resolved-container-wrapper {
    display: flex;
    gap: 16px;
    .inquiry-resolved-container {
      display: flex;
      align-items: center;
      gap: 8px;
      .inquiry-resolved-box {
        width: 16px;
        height: 12px;
        border-radius: 4px;
        &--answer_yes {
          background-color: #50cd89;
        }
        &--answer_no {
          background-color: #ef6767;
        }
      }
    }
  }
}
</style>
